// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__pUb5y","colBig":"styles_colBig__1sVMF","colSmall":"styles_colSmall__1sMbS"};